module.exports = __webpack_public_path__ + "img/chevron-double-down.473daf3a.svg";